<template><ProductDetailBase route-key="/products/oil-immersed" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "OilImmersedPage", components: { ProductDetailBase } };
</script>
